module.exports = __webpack_public_path__ + "img/biaoqian_xiaofangshuan.b309e842.png";